import {MissingTranslationHandler, MissingTranslationHandlerParams} from '@ngx-translate/core';

export class CustomMissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams) {
        if (params.key.startsWith('error')) {
            if (params.key.includes('.error-page.')) {
                return params.translateService.instant('error.error-page.general');
            }
            return params.translateService.instant('error.somethingWentWrongTryAgain');
        }
        
        return params.key.split('.').pop();
    }
}
